import { DataBean } from "../DataBean";

export class QuoteTransport extends DataBean {

    public async quoteTransportGuide(idTransportGuide: any, transportGuideDate: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.transportguides.TransportGuide_quoteTransportGuide_Number_java.util.Date_Number", [idTransportGuide, transportGuideDate, idEmployee]);
    }

}